import { render, staticRenderFns } from "./UmDbSetList.vue?vue&type=template&id=71b339aa&"
import script from "./UmDbSetList.vue?vue&type=script&lang=js&"
export * from "./UmDbSetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports